import { Resources, useResource } from "Translations/Resources";
import { useLoyaltiesEventsQuery } from "Api/Queries/Loyalty/useLoyaltiesEventsQuery";
import { useMemo } from "react";
import type { LoyaltyEventDto } from "Infrastructure/Api/Api";
import { Challenges } from "Components/Loyalty/Shared/Challenges/Variants/Challenges";
import { eventFilters } from "Components/Loyalty/Shared/Challenges/Categories/utils";
import type { ChallengeVariant } from "Components/Loyalty/Shared/Challenges/Categories/types";

const RESOURCES = Resources.Pages.Content.Loyalty.Challenges;

type Props = {
  variant?: ChallengeVariant;
};

export const LongTermChallenges = ({ variant = "card" }: Props) => {
  const { data, isLoading } = useLoyaltiesEventsQuery();
  const { t } = useResource();

  const longTermEvents = useMemo<Array<LoyaltyEventDto>>(() => {
    if (!data?.events) {
      return [];
    }
    return data.events.filter(eventFilters.longTerm);
  }, [data]);

  return (
    <Challenges
      challenges={longTermEvents}
      title={t(RESOURCES.LongTermChallenges.Title)}
      isLoading={isLoading}
      variant={variant}
    />
  );
};
